var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"home-scroller"},[_c('v-virtual-scroll',{attrs:{"height":"100","item-height":"20"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }